import { AxiosResponseHeaders } from 'axios';
import { CurrencySearchResponseDTO } from '../entities';
import { CurrencySearchResponseBody } from '../entities/CurrencySearchResponseDTO';

const currencySearchResponseDTOToCurrencySearchResponseAdapter = (
  data: CurrencySearchResponseDTO,
  headers?: AxiosResponseHeaders,
): CurrencySearchResponseBody => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { currencySearchResponseDTOToCurrencySearchResponseAdapter };
